import moment from 'moment';
import React from 'react'
import Pagination from './TablePagination'

const UiTable = ({ actionHandler, allData, DetailHandler, totalCount, paginationHandler, paginationHandlerNew,
    pageNumber, noOfRows, sorting, markAsImportant, tableType }) => {
    let rolesData = window.sessionStorage.getItem('rolesData');

    return (
        <div className='table-responsive full-height'>
            {allData.length > 0 ?
                <>
                    <div style={{ overflowX: 'auto' }}>
                        <table className='table credhub-table'>
                            <thead>
                                {
                                    tableType === "dealerTable" ?
                                        <tr>
                                            <th scope="col">Info</th>
                                            <th scope='col'>Mark Important</th>
                                            <th scope="col" style={{ cursor: 'pointer' }} onClick={(e) => sorting("firmName")}>
                                                <span>Firm Name</span>
                                                <i className='fa fa-sort table-sort' />
                                            </th>
                                            <th scope="col">Parent</th>
                                            <th scope="col">Reference Name</th>
                                            <th scope="col" style={{ cursor: 'pointer' }} onClick={(e) => sorting("name")}>Name  <i className='fa fa-sort table-sort' /></th>
                                            <th scope="col">Community Code</th>
                                            <th scope="col">Email Id</th>
                                            <th scope="col">Mobile Number</th>
                                            <th scope="col">Created At</th>
                                            {/* {
                                        rolesData && rolesData.includes("adminCommunityCreateAndEdit") ? */}
                                            <th scope="col">Edit</th>
                                            {/* : ""} */}
                                        </tr>
                                        : ''}
                                {
                                    tableType === "salesAgentTable" ?
                                        <tr>
                                            <th scope="col">Info</th>
                                            <th scope='col'>Mark Important</th>
                                        
                                            <th scope="col" style={{ cursor: 'pointer' }} onClick={(e) => sorting("name")}>Name  <i className='fa fa-sort table-sort' /></th>
                                            <th scope="col">Community Code</th>
                                            <th scope="col">Community Type</th>
                                            <th scope="col">Email Id</th>
                                            <th scope="col">Mobile Number</th>
                                            <th scope="col">Created At</th>
                                            {/* {
                                        rolesData && rolesData.includes("adminCommunityCreateAndEdit") ? */}
                                            <th scope="col">Edit</th>
                                            {/* : ""} */}
                                        </tr>
                                        : ''}
                            </thead>
                            <tbody>
                                {allData.map((row, i) => {
                                    return (
                                        <>
                                            {
                                                tableType === "dealerTable" ?
                                                    <tr key={i}>
                                                        <td>
                                                            <i className='fa fa-info-circle' onClick={e => DetailHandler(row)} />
                                                        </td>
                                                        <td><i className={row.important === true ? 'fa fa-star pointer colorYellow' : 'fa fa-star pointer colorGray'} style={{ color: row.important === true ? '#ffbd11' : "#8f8f8f" }} onClick={e => markAsImportant(row.communityId, row.important)}></i></td>
                                                        <td>{row.firmName}</td>
                                                        <td>{row.parentCommunityMemberName}</td>
                                                        <td>{row.referenceName}</td>
                                                        <td>{row.communityName}</td>
                                                        <td>{row.communityCode}</td>
                                                        <td>{row.email}</td>
                                                        <td>{row.mobileNo}</td>
                                                        <td>{row.createdOn ? moment(row.createdOn).format("DD MMM YYYY") : ""} </td>

                                                        {/* {
                                                rolesData && rolesData.includes("adminCommunityCreateAndEdit") ? */}
                                                        <td>
                                                            <button className='btn action-btn' onClick={e => actionHandler('edit', row)}>
                                                                <i className='fa fa-edit' />
                                                            </button>
                                                            <button className='btn action-btn' onClick={e => actionHandler('delete', row)}>
                                                                <i className='fa fa-trash-o' />
                                                            </button>
                                                        </td>
                                                        {/* : ""} */}
                                                    </tr>
                                                    : ''}
                                            {
                                                tableType === "salesAgentTable" ?
                                                    <tr key={i}>
                                                        <td>
                                                            <i className='fa fa-info-circle' onClick={e => DetailHandler(row)} />
                                                        </td>
                                                        <td><i className={row.important === true ? 'fa fa-star pointer colorYellow' : 'fa fa-star pointer colorGray'} style={{ color: row.important === true ? '#ffbd11' : "#8f8f8f" }} onClick={e => markAsImportant(row.communityId, row.important)}></i></td>
                                                        <td>{row.communityName}</td>
                                                        <td>{row.communityCode}</td>
                                                        <td>{row.communityType}</td>
                                                        <td>{row.email}</td>
                                                        <td>{row.mobileNo}</td>
                                                        <td>{row.createdOn ? moment(row.createdOn).format("DD MMM YYYY") : ""} </td>

                                                        {/* {
                                                rolesData && rolesData.includes("adminCommunityCreateAndEdit") ? */}
                                                        <td>
                                                            <button className='btn action-btn' onClick={e => actionHandler('edit', row)}>
                                                                <i className='fa fa-edit' />
                                                            </button>
                                                            <button className='btn action-btn' onClick={e => actionHandler('delete', row)}>
                                                                <i className='fa fa-trash-o' />
                                                            </button>
                                                        </td>
                                                        {/* : ""} */}
                                                    </tr>
                                                    : ''}
                                        </>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                    <Pagination

                        paginationHandlerNew={paginationHandlerNew}
                        totalCount={totalCount}
                        paginationHandler={paginationHandler}
                        pageNumber={pageNumber}
                        noOfRows={noOfRows}
                    />
                </>
                : null}
        </div>
    )
}

export default UiTable;